import EnUs from './en-US.svg'
import EsEs from './es-ES.svg'
import DeDE from './de-DE.svg'
import FrFR from './fr-FR.svg'
import ItIT from './it-IT.svg'
import PtBR from './pt-BR.svg'
// copied from https://github.com/HatScripts/circle-flags
// TODO fix blurry on Safari — replace Mask with border-radius

export const localeIcons = {
    'en-US': EnUs,
    'es-ES': EsEs,
    'de-DE': DeDE,
    'fr-FR': FrFR,
    'it-IT': ItIT,
    'pt-BR': PtBR,
}
